module.exports = __webpack_public_path__ + "img/drag.d76e86fe.png";